import React from 'react';
import { Link } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';

const ByUser = ({ username, to, className }) => {
  return (
    <Trans>
      by{' '}
      <Link className={className || 'text-white hover:underline'} to={to}>
        {username}
      </Link>
    </Trans>
  );
};

export default ByUser;
